"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHistory = exports.DayEvents = exports.StoredEvent = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../../device"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Events.Schema';
/*
 * `controllers/v2/fleet/events.js` (protocol v1)
 *
 * The controller returns the history rows as stored: the event is flattened
 * (`name`, `params`, `time` at the top level) next to the history fields
 * (`id`, `deviceId`, `createdAt`), as `@culligan-iot/db` `DbHistoryEvent`.
 */
exports.StoredEvent = Device.Capability.Event.Event.pipe(effect_1.Schema.omit('_tag'), effect_1.Schema.extend(Device.History.Event.pipe(effect_1.Schema.omit('event'))), effect_1.Schema.extend(effect_1.Schema.Struct({
    name: Device.Capability.Event.EventName,
    comp: effect_1.Schema.optionalWith(effect_1.Schema.Struct({
        auth: effect_1.Schema.Boolean,
        enhanced: effect_1.Schema.Boolean,
    }), { exact: true }).annotations({
        description: 'Dispense flags: authenticated session, enhancement dispensed',
    }),
}))).annotations({
    identifier: `${exports.NAMESPACE}.StoredEvent`,
    title: 'Stored event',
    description: 'One history event as stored: `name` is the event tag, `params` its payload',
});
exports.DayEvents = effect_1.Schema.Struct({
    day: effect_1.Schema.propertySignature(effect_1.Schema.Int).annotations({
        description: 'The UTC day the events fall in, Unix ms',
    }),
    totals: effect_1.Schema.propertySignature(effect_1.Schema.Record({ key: effect_1.Schema.String, value: effect_1.Schema.Int.pipe(effect_1.Schema.positive()) })).annotations({
        description: 'Number of events of each name on that day',
    }),
    events: effect_1.Schema.Array(exports.StoredEvent),
}).annotations({
    identifier: `${exports.NAMESPACE}.DayEvents`,
    title: 'Events of one day',
});
exports.EventHistory = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.DayEvents),
}).annotations({
    identifier: `${exports.NAMESPACE}.EventHistory`,
    description: 'One entry per whole day in the range, most recent first. Days without events have empty `events` and `totals`.',
});
//# sourceMappingURL=schema.js.map